module.exports = __webpack_public_path__ + "static/media/rocket.ebf9facb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rocket.png
// module id = 407
// module chunks = 0